import {
  blackColor,
  grayColor,
  hexToRgb,
  whiteColor,
} from "../../material-dashboard-pro-react";

const trendsStyle = () => ({
  clearFiltersButton: {
    color: grayColor[0],
    fontSize: "14px",
    cursor: "pointer",
    transition: "opacity 150ms",
    marginLeft: "8px",
    opacity: 0.7,
    "&:hover": {
      opacity: 1,
    },
  },
  actionWrapperOuter: {
    paddingLeft: "10px !important",
    paddingRight: "10px !important",
  },
  actionWrapper: {
    cursor: "pointer",
    opacity: "0.8",
    transition: "opacity 0.1s",
    "&:hover,&:active": {
      opacity: "1",
      "& div:first-child": {
        boxShadow: "0 0px 30px -10px rgba(" + hexToRgb(blackColor) + ", 0.3)",
      },
      "& div:first-child > svg": {
        transform: "scale(1.2)",
      },
    },
    "&:active": {
      "& div:first-child": {
        boxShadow:
          "0 0px 30px -10px rgba(" + hexToRgb(blackColor) + ", 0.7) !important",
      },
    },
  },
  actionDisabled: {
    opacity: "0.5 !important",
    pointerEvents: "none",
  },
  actionIcon: {
    color: grayColor[6],
    margin: "6px auto 0",
    width: "42px",
    height: "42px",
    border: "1px solid " + grayColor[11],
    borderRadius: "50%",
    textAlign: "center",
    lineHeight: "58px",
    transition: "box-shadow 0.2s",
    "& svg": {
      marginLeft: "1px",
      transition: "transform 0.2s",
      width: "26px",
      height: "26px",
    },
    "& .fab,& .fas,& .far,& .fal,& .material-icons": {
      width: "26px",
      fontSize: "26px",
    },
  },
  actionText: {
    color: grayColor[0],
    marginTop: "6px",
    marginBottom: "2px",
    textAlign: "center",
    fontSize: "10px",
  },
  dataCard: {
    marginTop: "8px",
    minHeight: "72vh",
  },
  followMe: {
    display: "inline",
    "& > span": {
      marginRight: "5px",
    },
  },
  followMeText: {
    color: whiteColor,
    backgroundColor: grayColor[6],
    borderRadius: "3px",
    padding: "2px 4px",
    transition: "all 500ms ease-in-out",
    marginLeft: "0",
    "&.new": {
      marginLeft: "20px",
      opacity: "0",
    },
  },
  followMeDivider: {
    color: grayColor[6],
    padding: "2px 0",
  },
  comparisonPeriodWrapper: {
    padding: "0",
    margin: "0",
    width: "100%",
    flex: 1,
    display: "flex",
    alignItems: "center",
    "& > div": {
      width: "100%",
      flex: 1,
    },
  },
  comparisonPeriodCard: {
    "& > div": {
      marginBottom: "0 !important",
    },
  },
  plCardWrapper: {
    marginTop: "8px",
  },
  plCard: {
    marginBottom: "0",
    marginTop: "0",
  },
  plCardBody: {
    padding: "0 !important",
  },
  plGridContainer: {
    paddingLeft: "5px",
    paddingRight: "5px",
  },
  indicatorsCard: {
    marginTop: "0",
  },
  indicatorsCardBody: {
    padding: "8px 4px",
  },
  cardNoMargin: {
    marginBottom: "0",
    marginTop: "0",
  },
  cardWaterfallMargin: {
    marginTop: "0",
    marginBottom: "8px",
  },
  indicatorsGrid: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr 1fr 1fr",
    gap: "20px",
  },
  indicatorWrapper: {
    textAlign: "center",
  },
  indicatorLabel: {
    fontSize: "12px",
    color: "#999",
    marginBottom: "4px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  indicatorLoadingWrapper: {
    height: "20px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  indicatorValue: {
    marginTop: "8px",
    fontSize: "32px",
    fontWeight: "300",
  },
  indicatorValueNegative: {
    color: "#f44336",
  },
  indicatorPercent: {
    marginTop: "8px",
    fontSize: "16px",
  },
  indicatorPercentNegative: {
    color: "#f44336",
  },
  buildingBlockCardBody: {
    padding: "12px",
  },
  buildingBlockTitle: {
    fontSize: "14px",
    color: "#999",
    textAlign: "center",
  },
  buildingBlockTitleWrapper: {
    display: "flex",
    justifyContent: "center",
  },
  waterfallTooltip: {
    minWidth: "400px !important",
  },
  waterfallTooltipContent: {
    textAlign: "left",
    fontSize: "14px",
    fontWeight: "300",
    padding: "4px",
    lineHeight: "1.2",
  },
  waterfallTooltipSection: {
    marginBottom: "15px",
  },
  waterfallTooltipSectionLast: {
    marginBottom: "0",
  },
  waterfallTooltipText: {
    marginTop: "5px",
  },
  waterfallTooltipItalic: {
    marginTop: "3px",
    fontStyle: "italic",
  },
  waterfallChartWrapper: {
    height: "240px",
    marginTop: "8px",
  },
  waterfallChartLoadingWrapper: {
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  // Driver tree styles
  driverTreeContainer: {
    padding: "8px",
  },
  driversCardBody: {
    padding: "8px",
  },
  driversRefreshingWrapper: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "20px",
  },
  driverRow: {
    display: "flex",
    alignItems: "center",
    padding: "4px 12px",
    transition: "all 0.2s",
  },
  driverRowWrapper: {
    marginLeft: "12px",
    marginBottom: "3px",
  },
  driverRowWrapperRoot: {
    marginLeft: "0",
    marginBottom: "3px",
  },
  driverRowIndented: {
    backgroundColor: "#fafafa",
  },
  driverRowBase: {
    backgroundColor: "#fff",
  },
  driverBorderLeft: {
    borderLeft: "4px solid",
  },
  driverCorner: {
    marginRight: "8px",
    fontSize: "12px",
    display: "flex",
    alignItems: "center",
  },
  driverCornerShape: {
    display: "inline-block",
    width: "10px",
    height: "10px",
    borderLeft: "2px solid",
    borderBottom: "2px solid",
    marginBottom: "4px",
  },
  driverRelevanceArrow: {
    marginRight: "12px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "24px",
    height: "24px",
  },
  driverRelevanceIcon: {
    fontSize: "16px",
    transition: "transform 0.3s",
  },
  driverInconsistencyTag: {
    padding: "3px 8px",
    fontSize: "11px",
    fontWeight: "600",
    textTransform: "uppercase",
    borderRadius: "4px",
    letterSpacing: "0.5px",
    textAlign: "center",
    marginRight: "12px",
  },
  driverNarrative: {
    flex: 1,
    fontSize: "14px",
    color: "#333",
  },
  driverElement: {
    cursor: "pointer",
    textDecoration: "underline",
    textDecorationStyle: "dotted",
    textUnderlineOffset: "3px",
    fontWeight: "600",
  },
  driverChangeValue: {
    marginLeft: "8px",
    fontSize: "12px",
    color: "#666",
    fontWeight: "500",
  },
  driverDrillButton: {
    marginLeft: "8px",
    cursor: "pointer",
    padding: "4px",
    borderRadius: "4px",
    transition: "all 0.2s",
    "&:hover": {
      backgroundColor: "#f0f0f0",
    },
  },
  driverDrillButtonExpanded: {
    transform: "rotate(90deg)",
  },
  driverDrillIcon: {
    fontSize: 18,
    color: "#999",
  },
  driverLoadingWrapper: {
    padding: "12px",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
  },
  // Section headers
  sectionHeader: {
    display: "flex",
    alignItems: "center",
    marginBottom: "8px",
    paddingBottom: "8px",
  },
  sectionHeaderIcon: {
    fontSize: 24,
    marginRight: "8px",
  },
  sectionHeaderTitle: {
    fontSize: "18px",
    fontWeight: "300",
    margin: 0,
  },
  sectionContent: {
    marginBottom: "32px",
  },
  // Loading and empty states
  centerLoading: {
    textAlign: "center",
    padding: "40px",
  },
  emptyState: {
    textAlign: "center",
    color: "#999",
    padding: "40px",
  },
  // Waterfall chart
  waterfallContainer: {
    height: "250px",
    marginTop: "8px",
  },
  waterfallTitleWrapper: {
    display: "flex",
    justifyContent: "center",
  },
  waterfallChartLoading: {
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  // Grid adjustments
  gridContainerTopNegative: {
    marginTop: "-28px",
  },
  // Action cursor helpers
  actionCursorPointer: {
    cursor: "pointer",
  },
  actionCursorDefault: {
    cursor: "default",
  },
  // Root Cause Path styles - Minimalist design
  rootCauseButton: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "2px 4px",
    marginLeft: "8px",
    borderRadius: "3px",
    cursor: "pointer",
    backgroundColor: "transparent",
    opacity: 0.5,
    transition: "all 0.2s",
    "&:hover": {
      opacity: 1,
    },
  },
  rootCauseButtonIcon: {
    fontSize: "12px",
    color: "#666",
  },
  rootCausePathContainer: {
    marginTop: "6px",
    marginLeft: "20px",
    borderLeft: "1px solid #e0e0e0",
    paddingLeft: "12px",
    paddingTop: "4px",
    paddingBottom: "4px",
    animation: "$fadeSlideIn 0.2s ease-out",
  },
  "@keyframes fadeSlideIn": {
    "0%": {
      opacity: 0,
      transform: "translateY(-10px)",
    },
    "100%": {
      opacity: 1,
      transform: "translateY(0)",
    },
  },
  rootCausePathTitle: {
    display: "flex",
    alignItems: "center",
    fontSize: "10px",
    color: "#999",
    marginBottom: "8px",
    fontWeight: "500",
    textTransform: "uppercase",
    letterSpacing: "0.3px",
  },
  rootCausePathTitleIcon: {
    fontSize: "10px",
    marginRight: "4px",
    color: "#999",
  },
  rootCausePathStep: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    padding: "4px 8px",
    marginBottom: "2px",
    backgroundColor: "transparent",
    borderLeft: "2px solid #e0e0e0",
    transition: "all 0.15s",
    animation: "$fadeSlideIn 0.2s ease-out",
    animationFillMode: "backwards",
    "&:hover": {
      backgroundColor: "#f8f8f8",
    },
  },
  rootCausePathStepFinal: {
    // Colors set via inline styles to use clientColor
  },
  rootCausePathStepConnector: {
    display: "flex",
    alignItems: "center",
    marginLeft: "2px",
    marginBottom: "2px",
    color: "#ddd",
    fontSize: "10px",
  },
  rootCausePathStepNumber: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "16px",
    height: "16px",
    borderRadius: "50%",
    backgroundColor: "#f0f0f0",
    color: "#888",
    fontSize: "9px",
    fontWeight: "600",
    marginRight: "6px",
    flexShrink: 0,
  },
  rootCausePathStepNumberFinal: {
    // Colors set via inline styles to use clientColor
  },
  rootCausePathStepDimension: {
    fontSize: "9px",
    color: "#aaa",
    marginRight: "4px",
    fontWeight: "500",
    textTransform: "uppercase",
  },
  rootCausePathStepElement: {
    fontSize: "11px",
    color: "#444",
    fontWeight: "500",
    cursor: "pointer",
    textDecoration: "none",
    borderBottom: "1px dotted #bbb",
    transition: "all 0.15s",
    // Hover color set via inline styles or parent component
  },
  rootCausePathStepArrow: {
    margin: "0 4px",
    color: "#ccc",
    fontSize: "10px",
  },
  rootCausePathStepEffect: {
    fontSize: "10px",
    color: "#777",
    display: "flex",
    alignItems: "center",
  },
  rootCausePathStepEffectBold: {
    fontWeight: "500",
  },
  rootCausePathStepMargin: {
    fontSize: "9px",
    color: "#aaa",
    marginLeft: "6px",
  },
  rootCausePathDeltaSymbol: {
    fontSize: "10px",
    fontWeight: "600",
    color: "#888",
    marginRight: "2px",
  },
  rootCausePathDeltaSeparator: {
    margin: "0 6px",
    color: "#ccc",
    fontSize: "10px",
  },
  rootCausePathAbsValue: {
    marginLeft: "6px",
    color: "#666",
    fontSize: "10px",
    fontWeight: "400",
    "& strong": {
      fontWeight: "600",
    },
  },
  rootCausePathLoading: {
    display: "flex",
    alignItems: "center",
    padding: "8px",
    color: "#888",
    fontSize: "11px",
  },
  rootCausePathLoadingText: {
    marginLeft: "8px",
  },
  rootCausePathEmpty: {
    padding: "8px",
    color: "#aaa",
    fontSize: "11px",
    fontStyle: "italic",
  },
  // Coverage Analysis styles (NEW)
  coverageProgressBar: {
    width: "100%",
    height: "4px",
    backgroundColor: "#e0e0e0",
    borderRadius: "2px",
    marginBottom: "10px",
    overflow: "hidden",
  },
  coverageProgressFill: {
    height: "100%",
    borderRadius: "2px",
    transition: "width 0.5s ease-out",
  },
  coverageResultStep: {
    marginBottom: "4px",
  },
  coverageContributionBadge: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    minWidth: "36px",
    padding: "2px 6px",
    marginLeft: "8px",
    marginRight: "8px",
    fontSize: "10px",
    fontWeight: "600",
    color: "#fff",
    borderRadius: "10px",
  },
  coverageRemainingRow: {
    display: "flex",
    alignItems: "center",
    padding: "6px 10px",
    marginTop: "4px",
    backgroundColor: "#f5f5f5",
    borderRadius: "4px",
    borderLeft: "3px solid #ccc",
  },
  coverageRemainingText: {
    fontSize: "10px",
    color: "#888",
    fontStyle: "italic",
  },
  rootCauseFinalBadge: {
    display: "none", // Hidden - visual highlight is enough
  },
  rootCauseFinalBadgeIcon: {
    display: "none",
  },
  // Additional root causes section (clients found along the path)
  additionalRootCausesSection: {
    marginTop: "8px",
    paddingTop: "8px",
    borderTop: "1px dashed #eee",
  },
  additionalRootCausesTitle: {
    display: "flex",
    alignItems: "center",
    fontSize: "10px",
    fontWeight: "500",
    color: "#999",
    marginBottom: "4px",
    textTransform: "uppercase",
    letterSpacing: "0.3px",
  },
  additionalRootCausesTitleIcon: {
    marginRight: "4px",
    fontSize: "10px",
  },
  additionalRootCausesSubtitle: {
    fontSize: "9px",
    color: grayColor[6],
    marginBottom: "6px",
    fontStyle: "italic",
  },
  additionalRootCauseStepBadge: {
    display: "none", // Hidden - position in path is clear from context
  },
  // Inline root cause branch (shown at the step where it was found)
  inlineRootCauseBranch: {
    display: "flex",
    alignItems: "flex-start",
    marginTop: "2px",
    marginLeft: "6px",
  },
  inlineRootCauseBranchConnector: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginRight: "4px",
    paddingTop: "2px",
  },
  inlineRootCauseBranchLine: {
    width: "1px",
    height: "6px",
    // Color set via inline styles to use clientColor
  },
  inlineRootCauseBranchIcon: {
    fontSize: "8px",
    // Color set via inline styles to use clientColor
  },
  inlineRootCauseStep: {
    flex: 1,
    marginLeft: "0 !important",
  },
});

export default trendsStyle;
